import { type TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { Content } from './Content';
import type { CollectionUpsell_CardCollectionScoreIncrease } from './__generated__/index.graphql';

const Wrapper = styled(Vertical).attrs({ gap: 0 })`
  padding: var(--double-unit) 0;
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
`;

type Props = {
  affectedCardCollections: CollectionUpsell_CardCollectionScoreIncrease[];
};

export const CollectionUpsell = ({ affectedCardCollections = [] }: Props) => {
  if (!affectedCardCollections.length) {
    return null;
  }
  return (
    <Wrapper>
      <Content affectedCardCollections={affectedCardCollections} />
    </Wrapper>
  );
};

CollectionUpsell.fragments = {
  cardCollectionScoreIncrease: gql`
    fragment CollectionUpsell_CardCollectionScoreIncrease on CardCollectionScoreIncrease {
      id
      ...CollectionUpsellContent_CardCollectionScoreIncrease
    }
    ${Content.fragments.cardCollectionScoreIncrease}
  ` as TypedDocumentNode<CollectionUpsell_CardCollectionScoreIncrease>,
};
